<h1>{{ ("availabilities" | i18n) || "Verfügbarkeiten" | titlecase }}</h1>

<div class="filter-container">
  <app-user-management-filter> </app-user-management-filter>
</div>
<app-availabilities-user-list
  *ngIf="user$ | async as user"
  [loggedInUser]="user">
</app-availabilities-user-list>
<div
  class="floating-actions-bar availabilities-actions-bar extra-space-actions-bar">
  <ng-container *ngIf="selectionSummary$ | async as selectionSummary">
    <button
      *ngIf="
        selectionSummary.inviteUsers.length ||
        selectionSummary.canBookUsers.length
      "
      (click)="submitSelection(selectionSummary, true)"
      class="primary-pill-button icon-left big-fab"
      type="button"
      data-cy="availability-overview-invite-button">
      <mat-icon svgIcon="send"></mat-icon>
      {{
        "inviteXUsers"
          | i18n
            : {
                inviteCount: (
                  selectionSummary.canBookUsers.length +
                  selectionSummary.inviteUsers.length
                ).toString()
              }
      }}
    </button>
    <button
      *ngIf="selectionSummary.canBookUsers.length"
      (click)="submitSelection(selectionSummary, false)"
      class="primary-pill-button icon-left big-fab"
      type="button"
      data-cy="availability-overview-invite-and-book-button">
      <mat-icon svgIcon="suitcase-job"></mat-icon>
      <ng-container *ngIf="selectionSummary.inviteUsers.length">
        {{
          "inviteXUsers"
            | i18n
              : { inviteCount: selectionSummary.inviteUsers.length.toString() }
        }}
        &
      </ng-container>
      {{
        "bookXUsers"
          | i18n: { bookCount: selectionSummary.canBookUsers.length.toString() }
      }}
    </button>
  </ng-container>
</div>
